import { HEX_HEIGHT_FACTOR } from '~/composables/grid/constants'
import type { GridShapesMenu, Shape } from '~/types/grid.types'
export enum SHAPE_IDS {
  HEX = 'Hex90',
  LARGE_DIAMOND = 'LargeDiamondHorizontal',
  LARGE_DIAMOND_60 = 'LargeDiamondHorizontal60',
  LARGE_DIAMOND_120 = 'LargeDiamondHorizontal120',
  SMALL_DIAMOND = 'SmallDiamondHorizontal',
  SMALL_DIAMOND_60 = 'SmallDiamondHorizontal60',
  SMALL_DIAMOND_120 = 'SmallDiamondHorizontal120',
  LARGE_TRIANGLE_TOP = 'LargeTriangleRight',
  LARGE_TRIANGLE_BOTTOM = 'LargeTriangleLeft',
  SMALL_TRIANGLE_TOP = 'SmallTriangleRight',
  SMALL_TRIANGLE_BOTTOM = 'SmallTriangleLeft',
}
export const SHAPES: Shape[] = [
  {
    type: 'hex',
    id: SHAPE_IDS.HEX,
    icon: 'Hex',
    prefix: 'Hex',
    label: 'Hex',
    w: 120,
    h: Math.round(120 * HEX_HEIGHT_FACTOR),
    sides: 6,
    radius: 60,
    rotation: 0,
  },
  {
    type: 'diamond',
    id: SHAPE_IDS.LARGE_DIAMOND,
    icon: 'LargeDiamond',
    prefix: 'LargeDiamond',
    label: 'Large Diamond',
    w: 120,
    h: Math.round(240 * HEX_HEIGHT_FACTOR),
    rotation: 90,
    children: [
      {
        type: 'diamond',
        id: SHAPE_IDS.LARGE_DIAMOND_60,
        icon: 'LargeDiamond',
        prefix: 'LargeDiamond',
        label: 'Large Diamond 60',
        w: 120,
        h: Math.round(240 * HEX_HEIGHT_FACTOR),
        rotation: 60 + 90,
      },
      {
        type: 'diamond',
        id: SHAPE_IDS.LARGE_DIAMOND_120,
        icon: 'LargeDiamond',
        prefix: 'LargeDiamond',
        label: 'Large Diamond 120',
        w: 120,
        h: Math.round(240 * HEX_HEIGHT_FACTOR),
        rotation: 120 + 90,
      },
    ],
  },
  {
    type: 'diamond',
    id: SHAPE_IDS.SMALL_DIAMOND,
    icon: 'SmallDiamond',
    prefix: 'Diamond',
    label: 'Small Diamond',
    w: 60,
    h: Math.round(120 * HEX_HEIGHT_FACTOR),
    rotation: 90,
    children: [
      {
        type: 'diamond',
        id: SHAPE_IDS.SMALL_DIAMOND_60,
        icon: 'SmallDiamond',
        prefix: 'Diamond',
        label: 'Small Diamond 60',
        w: 60,
        h: Math.round(120 * HEX_HEIGHT_FACTOR),
        rotation: 60 + 90,
      },
      {
        type: 'diamond',
        id: SHAPE_IDS.SMALL_DIAMOND_120,
        icon: 'SmallDiamond',
        prefix: 'Diamond',
        label: 'Small Diamond 120',
        w: 60,
        h: Math.round(120 * HEX_HEIGHT_FACTOR),
        rotation: 120 + 90,
      },
    ],
  },
  {
    type: 'triangle',
    id: SHAPE_IDS.LARGE_TRIANGLE_TOP,
    icon: 'LargeTriangle',
    prefix: 'LargeTriangle',
    label: 'Large Triangle',
    w: 120,
    h: Math.round(120 * HEX_HEIGHT_FACTOR),
    rotation: 90,
    children: [
      {
        type: 'triangle',
        id: SHAPE_IDS.LARGE_TRIANGLE_BOTTOM,
        icon: 'LargeTriangle',
        prefix: 'LargeTriangle',
        label: 'Large Triangle Flipped',
        rotation: 180 + 90, // svg icon is rotated
        w: 120,
        h: Math.round(120 * HEX_HEIGHT_FACTOR),
      },
    ],
  },
  {
    type: 'triangle',
    id: SHAPE_IDS.SMALL_TRIANGLE_TOP,
    icon: 'SmallTriangle',
    prefix: 'SmallTriangle',
    label: 'Small Triangle',
    w: 60,
    h: Math.round(60 * HEX_HEIGHT_FACTOR),
    rotation: 90,
    menuAlign: 'right',
    children: [
      {
        type: 'triangle',
        id: SHAPE_IDS.SMALL_TRIANGLE_BOTTOM,
        icon: 'SmallTriangle',
        prefix: 'SmallTriangle',
        label: 'Small Triangle Flipped',
        rotation: 180 + 90,
        w: 60,
        h: Math.round(60 * HEX_HEIGHT_FACTOR),
      },
    ],
  },
]

export const MENU: GridShapesMenu = {
  list: [
    {
      title: 'Shapes:',
      collapse: false,
      items: [
        ...SHAPES.filter((s: Shape) => [
          SHAPE_IDS.HEX,
          SHAPE_IDS.LARGE_DIAMOND,
          SHAPE_IDS.SMALL_DIAMOND,
          SHAPE_IDS.LARGE_TRIANGLE_TOP,
          SHAPE_IDS.SMALL_TRIANGLE_TOP,
        ].includes(s.id as SHAPE_IDS)),
      ],
    },
  ],
  default: SHAPES.find((s: Shape) => SHAPE_IDS.HEX === s.id),
}
